import { format } from "date-fns-tz"

const arrStatusCampaign = [{ text: "Активна", value: true, color: "green darken-2 white--text" },
  { text: "Неактивна", value: false, color: "grey darken-1 white--text" }]

export class CampaignModel {
  constructor (data /* campaignId, customerId, description, name, status */) {
    this.campaignId = data ? data.campaignId : 0
    this.customerId = data ? data.customerId : ''
    this.customerNumber = data ? data.customerNumber : ''
    this.description = data ? data.description : ''
    this.name = data ? data.name : ''
    this.status = data ? (data.status ? arrStatusCampaign[0] : arrStatusCampaign[1]) : arrStatusCampaign[1]
    this.updateDate = data ? this._updateDate(data.updateDate) : null
  }

  get statusHuman () {
    return this.status ? "Активно" : "Неактивно"
  }

  static clearItems () {
    return {
      campaignId: 0,
      customerId: "",
      description: "",
      name: "",
      status: false,
    }
  }

  toCsv (delimiter) {
    const delim = delimiter || ';'
    return this.campaignId + delim +
    this.customerId + delim +
    this.customerNumber + delim +
    this.description + delim +
    this.name + delim +
        this.updateDate + delim +
        this.status + delim + '\n'
  }

  _updateDate (updateDate) {
    const date = new Date(updateDate)
    return format(date, "dd.MM.yyyy HH:mm:ss")
  }
}

export const CampaignTitlesModel = [
  // { text: "Действия", value: "actions", sortable: false, show: true },
  {
    text: "Программа лояльности",
    value: "campaignId",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Наименование",
    value: "name",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Описание",
    value: "description",
    filterType: "text",
    filterValues: []
  },
  {
    text: "Последняя дата изменения",
    value: "updateDate",
    filterType: "date",
    filterValues: []
  },
  {
    text: "Статус",
    value: "status",
    filterType: "list_boolean",
    filterValues: arrStatusCampaign.map((m, index) => { return Object.fromEntries([['text', m.text], ['value', m.value]]) })
  },
]

export const CampaignHeadersModel = CampaignTitlesModel.map(m =>
    Object.fromEntries(
        Object.entries(m)
            .filter(([key]) => ['text', 'value'].includes(key))
    )
)

export let campaignCsv = ""
CampaignTitlesModel.forEach(m => (
    campaignCsv += `${m.text};`
))
campaignCsv = `${campaignCsv}\n`
